import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function AuthCallback() {
  const { setSession } = useAuth();
  const nav = useNavigate();
  useEffect(() => {
    const hash = window.location.hash.substring(1);
    const params = new URLSearchParams(hash);
    const sid = params.get("session_id");
    if (!sid) { nav("/login"); return; }
    api.post("/auth/google/session", { session_id: sid })
      .then(({ data }) => { setSession(data.token, data.user); nav(data.is_new ? "/choose-role" : "/dashboard"); })
      .catch(() => nav("/login"));
    // eslint-disable-next-line
  }, []);
  return <div className="py-40 text-center text-zinc-400" data-testid="auth-callback">Signing you in...</div>;
}
